const aiCoding = {
  en: {
    ai_coding: {
      fields: {
        prompt: 'Prompt',
        article_id: 'Article ID',
        text: 'Text',
        results: 'Results',
        provider: 'Provider',
        headline_provider: 'Headline Provider',
        model: 'Model',
        headline_ai_model: 'Headline Model',
        name: 'Name',
        allow_ai: 'Auto Code',
        analyze_images: 'Analyze Images'
      },
      table: {
        sr_no: 'S. No.',
        prompt: 'Prompt',
        name: 'Name',
        model: 'Model',
        allow_ai: 'Auto Code'
      },
      actions: {
        save: 'Save',
        test: 'Test',
        run: 'Run'
      },
      prompt_note: 'Note: for including the article in the prompt, use this notation {{article}}. This will ensure that the article is injected into the prompt during the AI - coding process',
      message: {
        saved: 'AI Coding prompt saved succesfully',
        deleted: 'AI Coding prompt deleted succesfully',
        testing: 'Testing prompt...',
        matched_tags: 'matched tags',
        unmatched_tags: 'Unmatched tags',
        unspecified_organization: 'Organization unspecified',
        malformed_json: "JSON response not well formed, unable to display additional details.",
        model_tooltip: 'Updating and saving your model selection will apply this model to all future AI coding tasks within this project.',
        allow_ai_toolip: 'If prompts are activated in AFR, autocode setting will be ignored.',
        duplicate: 'Prompt already exists.',
        default_models: 'Models selection updated successfully'
      },
      form: {
        code_articles: {
          title: 'AI Code',
          text: 'This action will trigger AI coding for all selected articles with a status of Assigned or Queued only. Articles that have any other status  will be skipped. Please make sure to assign the articles to the Auto Coder user before applying AI coding. Do you want to continue?'
        },
        buttons: {
          upload_image: 'Images',
          priority_queue: 'Continue with Priority'
        }
      }
    }
  }
}

module.exports.aiCoding = aiCoding;